/**
 * Version des Consent-Layouts/-Umfangs. Hochziehen, wenn sich Dienste,
 * Zwecke oder Texte des Cookie-Banners ändern → bestehende Einwilligungen
 * werden als veraltet behandelt und der Banner erneut angezeigt
 * (DSGVO-Nachweispflicht: nachvollziehbar, welcher Umfang eingewilligt wurde).
 *
 * Format: ISO-Monat (`YYYY-MM`), analog zu LEGAL_TEXT_VERSIONS.
 */
export const CONSENT_VERSION = '2026-06' as const;

/** Gültigkeitsdauer einer Einwilligung in Tagen (danach erneut fragen). */
export const CONSENT_TTL_DAYS = 180;
